import "./youtubePlayer.css";

const getYoutubeId = (url) => {
	const match = url.match(
		/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
	);
	return match ? match[1] : null;
};

const YoutubePlayer = ({ videos }) => {
	if (!videos || videos.length === 0) return null;

	return (
		<div className="youtube-section">
			<h2 className="youtube-section-title">
				<span className="youtube-icon">
					<svg width="28" height="28" viewBox="0 0 16 16" fill="currentColor">
						<path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z"/>
					</svg>
				</span>
				Vidéos
			</h2>
			<div className={`youtube-grid ${videos.length === 1 ? "youtube-single" : ""}`}>
				{videos.map((video, index) => {
					const videoId = getYoutubeId(video.link);
					if (!videoId) return null;

					return (
						<div className="youtube-card" key={index}>
							<div className="youtube-player-wrapper">
								<iframe
									src={`https://www.youtube.com/embed/${videoId}`}
									title={video.title}
									allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
									allowFullScreen
									className="youtube-iframe"
								></iframe>
							</div>
							{video.title && (
								<p className="youtube-video-title">{video.title}</p>
							)}
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default YoutubePlayer;
